module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "websiteAdd"
    }
  }, [_c('div', {
    staticClass: "input"
  }, [_c('div', [_c('Spin', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "fix": ""
    }
  }, [_c('Icon', {
    staticClass: "demo-spin-icon-load",
    attrs: {
      "type": "load-c",
      "size": "18"
    }
  }), _vm._v(" "), _c('div', [_vm._v("Loading")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "website-container"
  }, [_c('ul', [_vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: item.id
    }, [_c('div', {
      staticClass: "website-item-container"
    }, [_c('p', {
      attrs: {
        "title": item.mcaddr
      }
    }, [_vm._v(_vm._s(item.mcaddr))]), _vm._v(" "), (item.inputtype == 'rssDigest') ? _c('div', {
      staticClass: "m-t-b-10"
    }, [_c('span', {
      staticClass: "color-gray"
    }, [_vm._v("类型：")]), _vm._v("RSS摘要")]) : (item.inputtype == 'rssFullText') ? _c('div', {
      staticClass: "m-t-b-10"
    }, [_c('span', {
      staticClass: "color-gray"
    }, [_vm._v("类型：")]), _vm._v("RSS全文")]) : _c('div', {
      staticClass: "m-t-b-10"
    }, [_c('span', {
      staticClass: "color-gray"
    }, [_vm._v("类型：")]), _vm._v("Json全文")]), _vm._v(" "), _c('div', {
      staticClass: "btn-div"
    }, [(item.status == 'unaudited') ? _c('span', {
      staticClass: "status"
    }, [_vm._v("审核中...")]) : _vm._e(), _vm._v(" "), (item.status == 'auditpassed') ? _c('span', {
      staticClass: "status passed"
    }, [_vm._v("审核通过")]) : _vm._e(), _vm._v(" "), (item.status == 'auditnotpass') ? _c('span', {
      staticClass: "status nopassed"
    }, [_vm._v("审核未通过")]) : _vm._e(), _vm._v(" "), _c('Button', {
      staticClass: "unbind-btn",
      attrs: {
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.unbindWebsite(item.id)
        }
      }
    }, [_vm._v("解除绑定")])], 1), _vm._v(" "), _c('div', {
      staticClass: "m-t-b-10 align-left"
    }, [_c('div', {
      staticClass: "color-gray"
    }, [_vm._v("发布设置：")]), _vm._v(" "), _c('RadioGroup', {
      on: {
        "on-change": function (v) {
          _vm.changeWebPublishType(v, item.id)
        }
      },
      model: {
        value: (item.robopostxmt),
        callback: function($$v) {
          _vm.$set(item, "robopostxmt", $$v)
        },
        expression: "item.robopostxmt"
      }
    }, [_c('Radio', {
      attrs: {
        "label": "Y"
      }
    }, [_vm._v("自动同步")]), _vm._v(" "), _c('Radio', {
      attrs: {
        "label": "N"
      }
    }, [_vm._v("手动同步")])], 1)], 1), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.robopostxmt == 'Y'),
        expression: "item.robopostxmt == 'Y'"
      }],
      staticClass: "color-gray",
      attrs: {
        "title": "内容同步后,将自动发布"
      }
    }, [_vm._v("内容同步后,将自动发布")]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.robopostxmt == 'N'),
        expression: "item.robopostxmt == 'N'"
      }],
      staticClass: "color-gray",
      attrs: {
        "title": "内容同步后,内容为草稿,编辑后发布"
      }
    }, [_vm._v("内容同步后,内容为草稿,编辑后发布")])])])
  }), _vm._v(" "), (_vm.pageIndex == _vm.pageCount || _vm.pageCount == 0) ? _c('li', [_c('div', {
    staticClass: "website-item-container",
    on: {
      "click": _vm.showRule
    }
  }, [_c('p', {
    staticClass: "add-website"
  }, [_c('span', {
    staticClass: "dot-border"
  }, [_c('Icon', {
    attrs: {
      "type": "android-add"
    }
  })], 1), _c('span', {
    staticClass: "p-l-10"
  }, [_vm._v("添加内容源")])])])]) : _vm._e()], 2)])], 1), _vm._v(" "), (_vm.total > 0) ? _c('div', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "line-height": "24px",
      "margin-right": "10px"
    }
  }, [_vm._v("共" + _vm._s(_vm.pageCount) + "页")]), _vm._v(" "), _c('Page', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "total": _vm.total,
      "page-size": _vm.pageSize,
      "current": _vm.pageIndex,
      "size": "small"
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "id": "rulePop"
    },
    model: {
      value: (_vm.rulepop),
      callback: function($$v) {
        _vm.rulepop = $$v
      },
      expression: "rulepop"
    }
  }, [_c('p', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n      渠道开通协议\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "rule-pop-content"
  }, [_vm._v("\n      一、总则"), _c('br'), _vm._v("\n      1.1 保宝网的所有权和运营权归深圳市永兴元科技有限公司所有。"), _c('br'), _vm._v("\n      1.2 用户在注册之前，应当仔细阅读本协议，并同意遵守本协议后方可成\n      为注册用户。一旦注册成功，则用户与保宝网之间自动形成协议关系，用\n      户应当受本协议的约束。用户在使用特殊的服务或产品时，\n      应当同意接受相关协议后方能使用。"), _c('br'), _vm._v("\n      1.3 本协议则可由保宝网随时更新，用户应当及时关注并同意本站不承担\n      通知义务。本站的通知、公告、声明或其它类似内容是本协议的一部分。"), _c('br'), _c('br'), _vm._v("\n\n      二、服务内容"), _c('br'), _vm._v("\n      2.1 保宝网的具体内容由本站根据实际情况提供。"), _c('br'), _vm._v("\n      2.2 本站仅提供相关的网络服务，除此之外与相关网络服务有关的设备(如\n      个人电脑、手机、及其他与接入互联网或移动网有关的装置)及所需的费用\n      (如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费)\n      均应由用户自行负担。\n    ")]), _vm._v(" "), _c('Checkbox', {
    model: {
      value: (_vm.agreerule),
      callback: function($$v) {
        _vm.agreerule = $$v
      },
      expression: "agreerule"
    }
  }, [_vm._v("我已阅读并同意自媒体开通协议")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "shape": "circle",
      "disabled": !_vm.agreerule
    },
    on: {
      "click": _vm.ruleNext
    }
  }, [_vm._v("下一步")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "ghost",
      "shape": "circle"
    },
    on: {
      "click": _vm.ruleCancel
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "id": "addWebsitePop"
    },
    model: {
      value: (_vm.addwebsitepop),
      callback: function($$v) {
        _vm.addwebsitepop = $$v
      },
      expression: "addwebsitepop"
    }
  }, [_c('p', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n      新增输出内容\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "rule-pop-content"
  }, [_c('Form', {
    ref: "addWebsiteValidate",
    attrs: {
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "内容源地址",
      "prop": "rssUrl"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请勿提交单篇内容地址"
    },
    model: {
      value: (_vm.formValidate.rssUrl),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "rssUrl", $$v)
      },
      expression: "formValidate.rssUrl"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "内容源类型",
      "prop": "inputType"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formValidate.inputType),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "inputType", $$v)
      },
      expression: "formValidate.inputType"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "rssDigest"
    }
  }, [_vm._v("RSS摘要  无正文或仅包含正文摘要的RSS内容接口")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "rssFullText"
    }
  }, [_vm._v("RSS全文  包含全文内容的RSS内容接口")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "josnFullTest"
    }
  }, [_vm._v("JSON全文  包含全文内容的JSON格式内容源")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "发布设置",
      "prop": "robopostxmt"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formValidate.robopostxmt),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "robopostxmt", $$v)
      },
      expression: "formValidate.robopostxmt"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "Y"
    }
  }, [_vm._v("自动同步")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "N"
    }
  }, [_vm._v("手动同步")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "shape": "circle"
    },
    on: {
      "click": function($event) {
        return _vm.addWebsite('addWebsiteValidate')
      }
    }
  }, [_vm._v("添加")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-rule"
  }, [_vm._v("\n      说明："), _c('br'), _vm._v("\n         1、内容源支持：RSS全文、RSS摘要、网页列表。"), _c('br'), _vm._v("\n         2、为保证抓取准确性，请提交RSS全文或RSS摘要格式内容源（建议使用RSS全文）。"), _c('br'), _vm._v("\n         3、网页列表方式，系统会抓取页面中所有链接并分析，接入适合的内容。"), _c('br'), _vm._v("\n         4、检测出现异常情况时，请点击状态右侧“？”查看具体原因。"), _c('br'), _vm._v("\n         5、勾选「声明原创」的内容源，其中内容都将自动打上原创标签，创作者需保证这些内容均为原创。"), _c('br'), _vm._v("\n         6、禁止提交含大量转载、广告营销类内容的内容源。"), _c('br'), _vm._v("\n         7、内容源接入申请将在3个工作日内完成审核。如有疑问，请点击页面右侧「常见问题」下方的感叹号标识进行反馈。"), _c('br'), _c('br'), _vm._v("\n\n      提示："), _c('br'), _vm._v("\n      为提高内容曝光率及信息发布效率，您在本页面“内容源”提供链接，即表明希望并授权将您链接中的已有及将来的全部内容自动同步。\n      您提供该链接的行为，亦表明您承诺对该链接所有内容享有全部权利，并自愿自行承担因此带来的一切法律后果。\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e566e8c"}!./src/view/channel/websiteadd/index.html
// module id = 511
// module chunks = 123